module.exports = {"630202100":"碾伯镇","630202101":"雨润镇","630202102":"寿乐镇","630202103":"高庙镇","630202104":"洪水镇","630202105":"高店镇","630202106":"瞿昙镇","630202200":"共和乡","630202201":"中岭乡","630202202":"李家乡","630202203":"下营乡","630202204":"芦花乡","630202205":"马营乡","630202206":"马厂乡","630202207":"蒲台乡","630202208":"中坝乡","630202209":"峰堆乡","630202210":"城台乡","630202211":"达拉乡","630202400":"海东工业园区乐都工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630202.json
// module id = 3126
// module chunks = 0